export const noop: (...args: any[]) => void = () => undefined
